
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {namespace} from "vuex-class";

import preferencesService from "../../services/preferences.service";
import frontService from "@/services/front.service";
import TooltipDialog from "@/components/utils/TooltipDialog.vue";
import i18n from "@/plugins/vue-i18n";
import FieldIdentifierQualite from "@/components/utils/FieldIdentifierQualite.vue";

const userModule = namespace("userModule");

@Component({
    components: {TooltipDialog, FieldIdentifierQualite}
})
export default class FilesQualite extends Vue {

    @Prop() readonly selectedType;
    @Prop() readonly qualityFile;

    @userModule.State
    public user!: any;

    @userModule.Action
    public getUser;

    search = "";
    headers = [
        {
            text: "Nom",
            value: "name",
            width: '15vmax'
        },
        {
            text: "Date",
            value: "date",
            align: 'center',
            width: '15vmax'
        },
        {text: "Actions", value: "actions", sortable: false}
    ];
    name = "";
    files = [];
    uploadingFile = null;
    loading = false;
    dialogSelectId = false;
    itemsSelectId = [];
    selected = [];
    isLoadingData = true;
    error = false;
    errorMessage = '';
    info = false;
    interval;
    fileToUpload = null;
    selectedFileId: string = null;
    idFieldTypeFileInput = [];
    deleteModal = false;
    itemToDelete = "";

    @Watch("qualityFile", {deep: true})
    watch() {
        this.selected = [this.qualityFile];
    }

    refreshFiles() {
        this.isLoadingData = true;
        preferencesService.getPreferencesFiles(this.user.id, ['qualite']).then(res => {
            this.isLoadingData = false;
            this.files = res.data.message.Items;
        });
    }

    created() {
        if (this.user && this.user.id) {
            this.refreshFiles();
        } else {
            this.getUser().then(res => {
                this.refreshFiles();
            });
        }
    }

    uploaded(identifier) {
        this.isLoadingData = true;
        if (this.uploadingFile) {
            this.uploadingFile.identifiers = identifier;
            this.$emit('uploadFile', this.uploadingFile);
            this.uploadingFile = null;
        }
        this.dialogSelectId = false;
        this.refreshFiles();
    }

    preview(item) {
        this.itemsSelectId = [];
        this.idFieldTypeFileInput = [];
        preferencesService.previewFile(item.uuid).then(file => {
            this.itemsSelectId = file.data.message.Items;
            this.selectedFileId = item.uuid;
            if (item.identifiers) {
                this.idFieldTypeFileInput = item.identifiers;
            }
            this.dialogSelectId = true;
        });
    }

    deleteFile(item) {
      this.name = item.name;
      this.deleteModal = true;
      this.itemToDelete = item;
    }

    finalDelete(itemToDelete) {
      this.isLoadingData = true;
      preferencesService.deletePreferenceFiles(itemToDelete.uuid, this.user.id).then(res => {
        this.refreshFiles();
        if (this.qualityFile && this.qualityFile.uuid === itemToDelete.uuid) {
          this.$emit('uploadFile', null);
        }
      });
    }

    fileUploaded(resMessage) {
        this.dialogSelectId = true;
        this.itemsSelectId = resMessage.filePreview.Items;
        this.uploadingFile = resMessage.filePreference;
        this.$emit('uploadFile', this.uploadingFile);
        this.refreshFiles();
        this.loading = false;
        this.info = false;
    }

    clear() {
        this.error = false;
        this.info = false;
        clearInterval(this.interval);
        this.interval = null;
        this.loading = false;
    }

    checkUpload(userId, uuid) {
        preferencesService.fileCheck(userId, uuid).then((res) => {
            if (res.data.message.filePreference.pending === false) {
                this.fileUploaded(res.data.message);
                clearInterval(this.interval);
                this.interval = null;
            }
        });
    }

    uploadFile(event) {
        if (event) {
            const split = event.name.split('.');
            const fileType = split[split.length - 1];
            if (event.size <= 50000000 && (fileType === 'xlsx' || fileType === 'csv')) {
                this.loading = true;
                this.idFieldTypeFileInput = [];
                if (event.size > 20000000) {
                    this.info = true;
                }
                preferencesService
                    .uploadFileRepeller(event, this.user.id, 'qualite')
                    .then(res => {
                        if (res.data.error) {
                            if (res.data.error.type === 0) {
                                this.info = false;
                                this.errorMessage = i18n.tc('error.wrong_format');
                                this.error = true;
                                this.uploadingFile = null;
                                this.loading = false;
                                this.$nextTick(() => this.fileToUpload = null);
                            }
                        } else {
                            if (res.data.filePreference.pending === true) {
                                this.interval = setInterval(() => this.checkUpload(this.user.id, res.data.filePreference.uuid), 3000);
                                if (!this.info) {
                                    setTimeout(() => {
                                        if (this.interval) {
                                            this.info = true;
                                        }
                                    }, 5000);
                                }
                            } else {
                                this.fileUploaded(res.data.message);
                            }
                        }
                    })
                    .catch(e => {
                        console.log(e);
                        this.info = false;
                        this.errorMessage = i18n.tc('error.parsing');
                        this.error = true;
                        this.uploadingFile = null;
                        this.fileToUpload = null;
                    });
            } else {
                this.uploadingFile = false;
                if (event.size > 50000000) {
                    this.errorMessage = i18n.tc('error.file_too_big');
                    this.error = true;
                    this.uploadingFile = null;
                } else if (fileType !== 'xlsx' && fileType !== 'csv') {
                    this.errorMessage = i18n.tc('error.wrong_format');
                    this.error = true;
                    this.uploadingFile = null;
                } else {
                    this.uploadingFile = null;
                }
                this.$nextTick(() => this.fileToUpload = null);
            }
        } else {
            this.uploadingFile = null;
        }
    }

    closeModal() {
        this.dialogSelectId = false;
        this.fileToUpload = null;
        if (this.uploadingFile) {
            this.isLoadingData = true;
            preferencesService.deletePreferenceFiles(this.uploadingFile.uuid, this.user.id).then(res => {
                this.refreshFiles();
                this.uploadingFile = null;
                this.$emit('uploadFile', null);
            });
        }
    }

    customSort(items, index, isDesc) {
        return frontService.customSort('date', items, index, isDesc);
    }

    img(value) {
        return require('@/assets/' + value);
    }

    standardization(value) {
      if(value == "siren")
        return "Sociétés";
      if(value == "siret")
        return "Établissements";
      return value;
    }

    customFilter(value, search, item) {
        if(this.search) {
            const finalSearch = this.search.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            const finalValue = item.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
            return finalValue.includes(finalSearch);
        } else {
            return false;
        }
    }
}
